"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = exports.ListSubMenu = exports.ListItem = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var create_rocket_1 = require("../_util/create-rocket");
var tooltip_1 = require("../tooltip");
var dropdown_1 = require("../dropdown");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var config_context_1 = require("../_util/config-context");
var is_child_of_type_1 = require("../_util/is-child-of-type");
var noop_1 = require("../_util/noop");
var is_mobile_1 = require("../_util/is-mobile");
var use_outside_click_1 = require("../_util/use-outside-click");
var util_1 = require("../util");
exports.ListItem = react_1.forwardRef(function ListItem(_a, ref) {
    var children = _a.children, className = _a.className, current = _a.current, disabled = _a.disabled, selected = _a.selected, onClick = _a.onClick, tooltip = _a.tooltip, props = tslib_1.__rest(_a, ["children", "className", "current", "disabled", "selected", "onClick", "tooltip"]);
    var child = (react_1.default.createElement("li", tslib_1.__assign({}, props, { ref: ref, className: classnames_1.default(className, {
            "is-current": current && !selected,
            "is-disabled": disabled,
            "is-selected": selected,
        }), onClick: disabled ? null : onClick }), children));
    if (tooltip) {
        child = react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip }, child);
    }
    return child;
});
exports.ListItem.displayName = "ListItem";
exports.ListSubMenu = react_1.default.forwardRef(function ListSubMenu(_a, ref) {
    var label = _a.label, children = _a.children, _b = _a.placement, placement = _b === void 0 ? "right" : _b, _c = _a.trigger, trigger = _c === void 0 ? "hover" : _c, className = _a.className, disabled = _a.disabled, visible = _a.visible, current = _a.current, selected = _a.selected, _d = _a.onVisibleChange, onVisibleChange = _d === void 0 ? noop_1.noop : _d, _e = _a.onMouseEnter, onMouseEnter = _e === void 0 ? noop_1.noop : _e, _f = _a.onMouseLeave, onMouseLeave = _f === void 0 ? noop_1.noop : _f, _g = _a.onClick, onClick = _g === void 0 ? noop_1.noop : _g, props = tslib_1.__rest(_a, ["label", "children", "placement", "trigger", "className", "disabled", "visible", "current", "selected", "onVisibleChange", "onMouseEnter", "onMouseLeave", "onClick"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    var liRef = react_1.useRef(null);
    var enterTimerRef = react_1.useRef(null);
    var leaveTimerRef = react_1.useRef(null);
    var _h = tslib_1.__read(react_1.useState(false), 2), hover = _h[0], setHover = _h[1];
    var listen = use_outside_click_1.useOutsideClick(liRef).listen;
    react_1.useEffect(function () {
        return function () {
            clearTimeout(enterTimerRef.current);
            clearTimeout(leaveTimerRef.current);
        };
    }, []);
    var dropdownStyle = { position: undefined };
    var _j = tslib_1.__read(placement.split("-"), 2), basePlacement = _j[0], placementModifier = _j[1];
    if (basePlacement === "left") {
        Object.assign(dropdownStyle, {
            left: "auto",
            right: "100%",
        });
    }
    if (placementModifier === "end") {
        Object.assign(dropdownStyle, {
            top: undefined,
            transform: "translateY(-100%)",
            marginTop: 6,
        });
    }
    if (disabled) {
        return (react_1.default.createElement("li", tslib_1.__assign({}, props, { className: classnames_1.default(classPrefix + "-list__submenu", "is-disabled", className, {
                "is-current": current,
                "is-selected": selected,
            }) }), label));
    }
    var triggerProps = is_mobile_1.isMobile || trigger === "click"
        ? {
            onClick: function (event) {
                onClick(event);
                onVisibleChange(true);
                setHover(true);
            },
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
        }
        : {
            onClick: onClick,
            onMouseEnter: function (event) {
                onMouseEnter(event);
                clearTimeout(enterTimerRef.current);
                leaveTimerRef.current = setTimeout(function () {
                    onVisibleChange(true);
                    setHover(true);
                }, 150);
            },
            onMouseLeave: function (event) {
                onMouseLeave(event);
                clearTimeout(leaveTimerRef.current);
                enterTimerRef.current = setTimeout(function () {
                    onVisibleChange(false);
                    setHover(false);
                }, 150);
            },
        };
    if (is_mobile_1.isMobile || trigger === "click") {
        listen(function () {
            onVisibleChange(false);
            setHover(false);
        });
    }
    return (react_1.default.createElement("li", tslib_1.__assign({ ref: util_1.mergeRefs(ref, liRef) }, props, { className: classnames_1.default(classPrefix + "-list__submenu", className, {
            "is-hover": typeof visible !== "undefined" ? visible : hover,
            "is-current": current,
            "is-selected": selected,
        }) }, triggerProps),
        label,
        react_1.default.createElement(dropdown_1.DropdownBox, { style: dropdownStyle }, children)));
});
exports.ListSubMenu.displayName = "ListSubMenu";
exports.List = forward_ref_with_statics_1.forwardRefWithStatics(function List(_a, ref) {
    var _b;
    var className = _a.className, style = _a.style, children = _a.children, type = _a.type, split = _a.split, _c = _a.onScrollBottom, onScrollBottom = _c === void 0 ? function () { return null; } : _c;
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _d = tslib_1.__read(react_1.useState(false), 2), hasSubMenu = _d[0], setHasSubMenu = _d[1];
    react_1.useEffect(function () {
        react_1.default.Children.forEach(children, function (child) {
            if (is_child_of_type_1.isChildOfType(child, exports.ListSubMenu)) {
                setHasSubMenu(true);
            }
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    function handleBodyScroll(event) {
        var list = event.target;
        var scrollHeight = list.scrollHeight, scrollTop = list.scrollTop, clientHeight = list.clientHeight;
        if (scrollHeight <= Math.ceil(clientHeight + scrollTop + 1)) {
            onScrollBottom(event);
        }
    }
    var digits = String(react_1.default.Children.count(children)).length;
    var listClassName = classnames_1.default((_b = {},
        _b[classPrefix + "-list"] = true,
        _b[classPrefix + "-list--bullet"] = type === "bullet",
        _b[classPrefix + "-list--number"] = type === "number",
        _b[classPrefix + "-list--option"] = type === "option" || type === "option-group",
        _b[classPrefix + "-list--group"] = type === "option-group",
        _b[classPrefix + "-list--divider"] = split === "divide",
        _b[classPrefix + "-list--striped"] = split === "stripe",
        _b["is-2digits"] = type === "number" && digits === 2,
        _b["is-3digits"] = type === "number" && digits === 3,
        _b["is-4digits"] = type === "number" && digits > 3,
        _b[className] = className,
        _b));
    var Parent = type === "number" ? "ol" : "ul";
    return (react_1.default.createElement(Parent, { ref: ref, className: listClassName, style: tslib_1.__assign({ 
            // 多级菜单展开
            maxHeight: hasSubMenu ? "none" : undefined }, (style || {})), onScroll: handleBodyScroll }, children));
}, {
    GroupLabel: create_rocket_1.createRocket("GroupLabel", "li.@{prefix}-list__label"),
    Divider: create_rocket_1.createRocket("Divider", "li.@{prefix}-list__separate"),
    StatusTip: create_rocket_1.createRocket("TipItem", "li.@{prefix}-list__status"),
    SubMenu: exports.ListSubMenu,
    Item: exports.ListItem,
});
exports.List.displayName = "List";
//# sourceMappingURL=List.js.map